<template>
  <div class="page">
    <initio-panel :hide-submit="true" @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        <h1>Make Payment</h1>
      </template>
      <template v-slot:before_form>

        <div class="box" v-if="!client.cli_num">
          <h3 class="title is-4">Your details</h3>
          <div class="columns is-multiline">
            <div class="column is-6">
              <p class="mb-1">{{ answers['Vehicle.CreateAccount'].create_account_first_name }} {{ answers['Vehicle.CreateAccount'].create_account_last_name}}</p>
              <p>{{ fulltextDate(answers['Vehicle.CreateAccount'].create_account_dob)  }}</p>
            </div>
            <div class="column is-6">
              <p class="mb-1">{{ answers['Vehicle.CreateAccount'].create_account_email }}</p>
              <p class="mb-1">{{ answers['Vehicle.CreateAccount'].create_account_phone }}</p>
              <p>{{ answers['Vehicle.CreateAccount'].create_account_address }}</p>
            </div>
          </div>
        </div>

        <CoverDetails></CoverDetails>
        <MainDriverDetails></MainDriverDetails>

        <div class="box">
          <div class="columns">
            <div class="column">
              <h3 class="title is-4">{{ paymentInterval(true) }} payment</h3>
            </div>
            <div class="column">
              <div class="is-flex is-justify-content-flex-end">
                <router-link :to="{ name: 'Vehicle.Quote'}">
                  <span v-if="paymentInterval() == 'monthly'">Change to yearly payment</span><span v-else>Change to monthly payment</span>
                  </router-link>
              </div>
            </div>
          </div>
          <div class="mb-3" v-if="paymentInterval() == 'monthly'">
            <strong>Credit or debit cards payments only</strong>, we are unable to provide monthly payments via direct debit, automatic or manual payments. Future payments will automatically be deducted from the registered card, the card details can be updated at any time from your account.
          </div>
          <StripePayment v-if="paymentInterval() == 'monthly'" v-on:success-response-data="setResponseParamsAndRedirectToSuccessPage" />
          <template v-if="paymentInterval() == 'yearly'">
            <AnnualPayment />
          </template>
        </div>

        <div class="next-billing-cycle-info" v-if="next_period_total_cost_inc_gst">
          <strong><template v-if="paymentInterval() == 'monthly'">Credit card </template><template v-else>Your payment method </template>will be charged today</strong> for cover starting from <strong>{{ fulltextDate(answers['Vehicle.Confirm'].vehicle_confirm_insurance_start) }}</strong>.
          <div v-if="paymentInterval() == 'monthly'">Cover will <strong>automatically renew each month</strong> and your next payment will be <strong>{{ next_period_total_cost_inc_gst | toCurrency }}</strong> charged on <strong>{{ fulltextDate(next_period_billing_date_sql) }}</strong>.</div>
          You will be instantly emailed your policy documentation, including your invoice.
        </div>

      </template>
      <template v-slot:sidebar>
        <initio-summary-payment class="info-box" />
        <disclosure-block />
      </template>
    </initio-panel>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummaryPayment from '@/components/partials/SummaryPayment.vue'
import StripePayment from '@/components/partials/StripePayment.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import AnnualPayment from '@/components/partials/AnnualPayment.vue'
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'
import { toCurrency } from '@/helpers/currencyHelper.js'
import store from "../../../store/store";
import DisclosureBlock from "@/components/partials/DisclosureBlock";
import CoverDetails from '@/components/partials/CoverDetails';
import MainDriverDetails from '@/components/partials/MainDriverDetails'
import { api } from '@/store/store.js'
const axios = require("axios");

export default {
  components: {
    DisclosureBlock,
    InitioPanel,
    InitioSummaryPayment,
    AnnualPayment,
    StripePayment,
    CoverDetails,
    MainDriverDetails
  },
  mixins: [
    stepSubmit
  ],
  created () {
      this.$store.commit('updateSchema', []); // clear previous schema, as no schema for this page
  },
  mounted () {      
    this.getNextPeriodData();
  },
  methods: {
    toCurrency,
    fulltextDate,
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
        }, error => {
          console.error("VehiclePayment Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    },
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    },
    // Listen for the success Event to redirect to success page ( comes from either stripe or windcave component )
    // TODO - how do we de-duplicate this method from New & Alt payment page templates?
    setResponseParamsAndRedirectToSuccessPage(success_data){
      // Ideally we should be going through standard submit instead of manually adding data here
      let successPage = '';

      store.commit(
          'updateBackendData',
          {'Vehicle.Success': success_data}
      );
      successPage = "Vehicle.Success";

      store.getters.currentSession.stepPath.push(successPage);

      // Handle new-client flow ( so that the header dashboard button turns up )
      if( ! this.isLoggedIn ){
        this.$store.dispatch('getClientData',{ forceRefresh: true })
      }


      setTimeout(() => {
        // route to next page
        this.$router.push({name: successPage });
        // scroll to top
        window.scrollTo(0,0);
      }, 600); // Give some time to show a success message

    },

    getNextPeriodData() {

        this.errors = [];
        this.next_period_total_cost_inc_gst = null;
        this.next_period_billing_date_sql = null;

        axios.post(`${api.url + api.version}vehicle/new/next-period-premium/${this.sessionId()}`)
            .then(response => {
              // this.quoteIsLoading = false;
              // console.log('next period data', response);

              if (response.data.results && response.data.results.total_cost_inc_gst && response.data.results.next_billing_date_sql ) {
                const results = response.data.results;
                // this.next_period_data.total_cost_inc_gst = this.toCurrency(results.total_cost_inc_gst); // todo generalise this method from quote
                this.next_period_total_cost_inc_gst = results.total_cost_inc_gst;
                this.next_period_billing_date_sql = results.next_billing_date_sql;

              } else {
                console.error("Problem confirming next billing cycle for vehicle", response.data);
                this.errors.push('Problem confirming next billing cycle. Please go back and try again.');
              }

            }, error => {
              
              console.error("Problem confirming next billing cycle. Please go back and try again.");
              this.errors.push('Problem confirming next billing cycle. Please go back and try again.');
            });
        },

  },
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      answerLabel: 'getAnswerLabel',
      getAnswer: 'getAnswer',
      sessionId: 'getSessionId',
      client: 'client',
      paymentInterval: 'getPaymentInterval',
      isAltFlow: 'isAltFlow',
      isLoggedIn: 'isLoggedIn',
    })
  },
  data () {
    return {
      errors: [],
      cover_details: [],
      next_period_total_cost_inc_gst: null,
      next_period_billing_date_sql: null,
      modalOpen: false,
      paymentMethod: 'windcave',
    }
  }
}

</script>

<style scoped lang="scss">
  @import '~@/scss/partials/icons.scss';

  ::v-deep {
    .button {
      &--feature {
        padding: 0.1rem 0.4rem;
        height: auto;
        line-height: 0.8rem;
        vertical-align: middle;
        margin-top: -0.15rem;
        display: inline-block;
        margin-left: 0.4rem;
        pointer-events: none;

        &.is-primary {
          background: none;
          border: 1px solid $initio-green;
          color: $initio-green;
        }
        &.is-danger {
          background: none;
          border: 1px solid $red;
          color: $red;
        }
      }
    }

    div.column > .formulate-input-element {
      margin: 0;
      padding: 0;
    }

    .chosen-vehicle-block {
      padding: 0;
      background: none;
      border: none;
    }
  }

  .next-billing-cycle-info {
    font-size: 14px;
    color: $grey-text;
    strong {
      color: $grey-text;
    }
  }  

</style>